export default __webpack_public_path__ + "static/media/background-4.7e27fd9f.png";